export const CloseIcon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="18.002" y="16.328" width="2.36681" height="23.0912" rx="1.1834" transform="rotate(135 18.002 16.328)"
              fill="#2D3D49"/>
        <rect x="1.67383" y="18.0015" width="2.36681" height="23.0912" rx="1.1834"
              transform="rotate(-135 1.67383 18.0015)" fill="#2D3D49"/>
    </svg>
)
